<template>
  <div>
    <!-- title -->
    <v-row class="py-3 my-10" align="center" justify="center">
      <!-- <v-orb class="mr-3" /> -->
      <h2 class="text--secondary font-weight-medium">Agent Studio</h2>
    </v-row>
    <!-- end title -->

    <!-- loader -->
    <v-row v-if="$store.state.agents.retrieveLoader">
      <v-col cols="2" v-for="n in 6" :key="n">
        <v-skeleton-loader type="article" />
      </v-col>
    </v-row>
    <!-- end loader -->

    <!-- empty state -->
    <v-row v-else-if="!agentsList.length" class="py-8 text-center">
      <v-icon size="56" color="grey lighten-1">mdi-robot-outline</v-icon>
      <div class="mt-3 subtitle-1 font-weight-medium text--secondary">Sin agentes configurados</div>
      <div class="body-2 text--disabled mt-1 mb-6">Crea tu primer agente para automatizar tareas de cobranza o facturación.</div>
      <v-btn color="primary" :to="{ name: 'AgentCreate' }">Crear agente</v-btn>
    </v-row>
    <!-- end empty state -->

    <!-- agents grid -->
    <v-row v-else align="center" justify="center">
      <template v-for="agent in agentsList">
        <v-card class="ma-3 card-apps" :key="agent.id" :to="{ name: 'AgentRetrieve', params: { id: agent.id } }" width="180">
          <v-card-text class="pa-2">
            <div class="d-flex align-center mb-3">
              <v-avatar class="outlined rounded-sm" size="100%">
                <img :alt="agent.name" :src="require(`@/assets/appAsset-agents-${agent.avatar}.jpg`)" />
              </v-avatar>
            </div>
            <div class="d-flex align-center">
              <span class="body-2 text--secondary font-weight-medium">{{ agent.name }}</span>
            </div>
          </v-card-text>
        </v-card>
      </template>

      <!-- add new agent -->
      <v-btn class="ma-2" color="secondary" fab large outlined :to="{ name: 'AgentCreate' }">
        <v-icon size="32">mdi-plus</v-icon>
      </v-btn>
      <!-- end add new agent -->
    </v-row>
    <!-- end agents grid -->
  </div>
</template>

<script>
import ListViewMixin from '@/mixins/ListViewMixin'
import { mapState } from 'vuex'
import { agentAvatars } from '@/collections/agents'

import VOrb from '@/components/ux/VOrb.vue'

export default {
  mixins: [ListViewMixin],
  components: {
    VOrb
  },
  computed: {
    ...mapState({
      agentsList: state => state.agents.agentsList,
      agentsCount: state => state.agents.agentsCount
    }),
    count () {
      return this.agentsCount
    }
  },
  methods: {
    getList () {
      this.$store.dispatch('agents/LIST', {
        resource: 'agents',
        query: this.$route.query
      })
    },
    avatarConfig (avatar) {
      return agentAvatars.find(a => a.value === avatar) || agentAvatars[0]
    },
    kindLabel (kind) {
      const map = { collections: 'Cobranza', billing: 'Facturación', custom: 'Personalizado' }
      return map[kind] || kind
    },
    statusColor (status) {
      const map = {
        active: { bg: 'green lighten-5', text: 'green darken-2' },
        paused: { bg: 'orange lighten-5', text: 'orange darken-2' },
        draft: { bg: 'grey lighten-3', text: 'grey darken-1' },
        archived: { bg: 'blue-grey lighten-5', text: 'blue-grey darken-1' }
      }
      return map[status] || { bg: 'grey lighten-3', text: 'grey darken-1' }
    },
    statusLabel (status) {
      const map = { active: 'Activo', paused: 'Pausado', draft: 'Borrador', archived: 'Archivado' }
      return map[status] || status
    }
  }
}
</script>
